import React from "react";
import Login from "../Pages/Login/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Complaints from "../Pages/Complaints/Complaints";
import ViewComplaints from "../Pages/Complaints/ViewComplaints";
import ComplaintCategory from "../Pages/ComplaintCategory/ComplaintCategory";
import AddComplaintCategory from "../Pages/ComplaintCategory/AddComplaintCategory";
import BusinessCategory from "../Pages/BusinessCategory/BusinessCategory";
import EditBusinessCategory from "../Pages/BusinessCategory/EditBusinessCategory";
import EditComplaintCategory from "../Pages/ComplaintCategory/EditComplaintCategory";
import AddBusinessCategory from "../Pages/BusinessCategory/AddBusinessCategory";
import BusinessProfile from "../Pages/BusinessProfiles/BusinessProfile";
import AddBusinessProfile from "../Pages/BusinessProfiles/AddBusinessProfile";
import EditBusinessProfile from "../Pages/BusinessProfiles/EditBusinessProfile";
import Users from "../Pages/Users/Users";
import ViewUser from "../Pages/Users/ViewUser";
import ErrorComponent from "../Components/Error/Error";
import Settings from "../Pages/Settings/Settings";
import Admins from "../Pages/Admins/Admins";
import AddAdmin from "../Pages/Admins/AddAdmin";
import UpdateAdmin from "../Pages/Admins/UpdateAdmin";
import Profile from "../Pages/Admins/Profile";
import ResetPassword from "../Pages/Login/ResetPassword";
import OtpVerify from "../Pages/Login/OtpVerify";
import NewPassword from "../Pages/Login/NewPassword";

const AppRoutes = [
  {
    isProtectedAuth: false,
    path: "/login",
    element: <Login />,
  },
  {
    isProtected: true,
    path: "/",
    element: <Dashboard />,
  },
  {
    isProtected: true,
    path: "/complaints",
    element: <Complaints />,
  },
  {
    isProtected: true,
    path: "/view-review/:id",
    element: <ViewComplaints />,
  },
  {
    isProtected: true,
    path: "/complaint-category",
    element: <ComplaintCategory />,
  },
  {
    isProtected: true,
    path: "/addcomplaintcategory",
    element: <AddComplaintCategory />,
  },
  {
    isProtected: true,
    path: "/businesscategory",
    element: <BusinessCategory />,
  },
  {
    isProtected: true,
    path: "/editbusinesscategory/:id",
    element: <EditBusinessCategory />,
  },
  {
    isProtected: true,
    path: "/editcomplaintcategory/:id",
    element: <EditComplaintCategory />,
  },
  {
    isProtected: true,
    path: "/addbusinesscategory",
    element: <AddBusinessCategory />,
  },
  {
    isProtected: true,
    path: "/businessprofile",
    element: <BusinessProfile />,
  },
  {
    isProtected: true,
    path: "/addbusinessprofile",
    element: <AddBusinessProfile />,
  },
  {
    isProtected: true,
    path: "/editbusinessprofile/:id",
    element: <EditBusinessProfile />,
  },
  {
    isProtected: true,
    path: "/viewuser/:id",
    element: <ViewUser />,
  },
  {
    isProtected: true,
    path: "/users",
    element: <Users />,
  },
  {
    isProtected: true,
    path: "/settings",
    element: <Settings />,
  },
  {
    isProtected: true,
    path: "/admins",
    element: <Admins />,
  },
  {
    isProtected: true,
    path: "/add-admin",
    element: <AddAdmin />,
  },
  {
    isProtected: true,
    path: "/update-admin/:id",
    element: <UpdateAdmin />,
  },
  {
    isProtected: true,
    path: "/profile",
    element: <Profile />,
  },
  {
    isProtected: false,
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    isProtected: false,
    path: "/verify-otp",
    element: <OtpVerify />,
  },
  {
    isProtected: false,
    path: "/new-password",
    element: <NewPassword />,
  },
];

export default AppRoutes;
